/** @jsx jsx */
import { Embed, jsx } from "theme-ui";
import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Cross2Icon, PlayIcon } from "@radix-ui/react-icons";
import BuilderImage from "../image/builder-image";

export type VideoEmbedProps = { url: string; poster: string };
export const VideoEmbed: React.FC<VideoEmbedProps> = ({ poster, url }) => {
  return (
    <div className=" h-full">
      <BuilderImage
        url={poster}
        alt={"hero image of cartoon trail route"}
        lazy={false}
        fetchPriority="high"
        aspectRatio="367/314"
        className="w-full"
      />
      <div className="absolute flex flex-row top-0 left-0 w-full h-full justify-center items-center ">
        <VideoInDialog url={url} />
      </div>
    </div>
  );
};

export default VideoEmbed;

const VideoInDialog = ({ url }: { url: string }) => (
  <Dialog.Root>
    <Dialog.Trigger asChild>
      <button
        id={"button"}
        aria-controls="button"
        className=" w-[64px] h-[64px] text-white bg-gray-900 bg-opacity-60 border-2 border-white  inline-flex items-center justify-center rounded-full"
        aria-label="Play video"
      >
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M5.536 21.886a1.004 1.004 0 0 0 1.033-.064l13-9a1 1 0 0 0 0-1.644l-13-9A1 1 0 0 0 5 3v18a1 1 0 0 0 .536.886z"
          />
        </svg>
      </button>
    </Dialog.Trigger>
    <Dialog.Portal>
      <Dialog.Overlay className="bg-slate-700 data-[state=open]:animate-overlayShow fixed inset-0" />
      <Dialog.Content className="data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw]  translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none">
        <Embed className="max-h-[80vh]" width={500} src={url} />

        <Dialog.Close asChild>
          <button
            className="  absolute top-[10px] right-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
            aria-label="Close"
          >
            <Cross2Icon />
          </button>
        </Dialog.Close>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
